import PriceRangeFilter from './PriceRangeFilter.component';

export default PriceRangeFilter;